import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Slider from 'react-slick/lib/slider';
import { homeapple, homegoogle } from '../../MediaConstants/Index';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

const TopSliderHome = (props) => {
    const navigate = useNavigate('/');
    function SampleNextArrow(props) {
        const { className, style, onClick } = props;
        return (
            <div
                className='Slider_top_custom_arrows-next'
                // style={{ ...style, display: "block", background: "red", height: "80px", width: "80px" }}
                onClick={onClick}
            >
                <ArrowBackIosIcon />
            </div>
        );
    }

    function SamplePrevArrow(props) {
        const { style, onClick } = props;
        return (
            <div
                className="Slider_top_custom_arrows"
                // style={{ ...style, display: "block", background: "green", height: "80px", width: "80px" }}
                onClick={onClick}
            >
                <ArrowForwardIosIcon />
            </div>
        );
    }

    const settings = {
        dots: true,
        infinite: true,
        speed: 1200,
        slidesToShow: 1,
        slidesToScroll: 1,
        nextArrow: <SampleNextArrow />,
        prevArrow: <SamplePrevArrow />,
        autoplay: true,
        autoplaySpeed: 6000,
        appendDots: dots => (
            <div
                style={{
                    // backgroundColor: "black",
                    borderRadius: "10px",
                    color: "white",
                    padding: "10px"
                }}
            >
                <ul style={{ margin: "0px" }}> <span style={{ color: "white" }}>{dots}</span> </ul>
            </div>
        ),
    };

    // "Helvetica Rounded LT Std" !important

    return (
        <div className='TopSliderHome'>
            <Slider {...settings} className="slider_top_home">
                {/* wow animate__animated animate__fadeInLeft */}
                {/* text-center */}
                <div className="banner-content-wrapper pl-1">
                    <h1 className='fnt_head_sliderz_top mb-0'>Mister Softee</h1>
                    {/*classNmae=" red_font " */}
                    <h2 className='fnt_head_sliderz_top'> NOW ON DEMAND <br />EXCLUSIVELY IN BROOKLYN</h2>
                    {/* <p className='pr-4'>Whether you want ice at your wedding, birthday party, workplace, or school fundraiser, our new and cool ice cream truck can be available on-demand</p> */}
                    <Link to="/ondemand" className="btn">Learn More </Link>
                    <button onClick={() => { props.setChangeHomeBanner(2) }} className="btn free_topping ml-2">Free Cone</button>
                </div>
                <div className="banner-content-wrapper  pl-1">
                    <h1 className='fnt_head_sliderz_top_two '>Mister Softee <br/> On Demand App</h1>
                    <h2 className='red_font'>Available Now</h2>
                    <p className='pr-4'>What can be more exciting than ordering your favorite ice cream truck via a mobile application?</p>
                    {/* <p className='pr-4'>Whether you want ice cream at your wedding, birthday party, workplace, or school fundraiser, we got you covered.</p> */}
                    <div>
                        {/* <button onClick={() => { navigate('/bookevent') }} className="btn bt-cus-icecrm mb-4">ICE CREAM AT YOUR DOOR? YES PLEASE.</button> */}
                    </div>
                    {/* justify-center */}
                    <div className='d-flex '>
                        <a href="https://www.apple.com/app-store">
                            <img src={homeapple} className="img-fluid mr-2" alt="" />
                        </a>
                        <a href="https://play.google.com/store">
                            <img src={homegoogle} className="img-fluid" alt="" />
                        </a>
                    </div>
                    {/* <Link to="/ondemand" className="btn">On Demand</Link>
                    <button onClick={() => { props.setChangeHomeBanner(2) }} className="btn free_topping ml-2">Get Free Topping</button> */}
                </div>
            </Slider>
        </div>
    );
};

export default TopSliderHome;